import React from 'react';
import { Mic, Loader2 } from 'lucide-react';
import { VoiceViewTab } from '@/types/voice/favorites';

interface VoiceEmptyStateProps {
  activeTab: VoiceViewTab;
  isLoadingAllVoices: boolean;
  isLoadingRecommended?: boolean;
  searchQuery?: string;
}

export const VoiceEmptyState: React.FC<VoiceEmptyStateProps> = ({
  activeTab,
  isLoadingAllVoices,
  isLoadingRecommended,
  searchQuery
}) => {
  // Loading state for "All" tab
  if (activeTab === 'all' && isLoadingAllVoices) {
    return (
      <div className="text-center py-12">
        <Loader2 className="h-12 w-12 animate-spin text-genie-primary mx-auto mb-4" />
        <h3 className="text-lg font-medium text-gray-900 mb-2">
          Loading all voices...
        </h3>
        <p className="text-gray-500">
          This may take a moment as we load over 2000 voices
        </p>
      </div>
    );
  }

  // Loading state for "Recommended" tab
  if (activeTab === 'recommended' && isLoadingRecommended) {
    return (
      <div className="text-center py-12">
        <Loader2 className="h-12 w-12 animate-spin text-genie-primary mx-auto mb-4" />
        <h3 className="text-lg font-medium text-gray-900 mb-2">
          Searching voices...
        </h3>
        <p className="text-gray-500">
          Finding voices that match your criteria
        </p>
      </div>
    );
  }

  // Empty states for different tabs
  const emptyStateContent = {
    favorites: {
      title: 'No favorite voices yet',
      description: 'Click the heart icon on any voice to add it to your favorites'
    },
    recommended: {
      title: 'No preselected voices available',
      description: 'Check back later for curated voices'
    },
    all: {
      title: searchQuery ? 'No voices found' : 'No voices available',
      description: searchQuery
        ? 'Try adjusting your filters or search query'
        : 'No voices are currently available'
    }
  };

  const content = emptyStateContent[activeTab] || emptyStateContent.all;

  return (
    <div className="text-center py-12">
      <Mic className="h-12 w-12 text-gray-400 mx-auto mb-4" />
      <h3 className="text-lg font-medium text-gray-900 mb-2">
        {content.title}
      </h3>
      <p className="text-gray-500">
        {content.description}
      </p>
    </div>
  );
};

export default VoiceEmptyState;